import { Field, FieldTokens, InputTokens } from '@cp/ui';
import { styled } from '../../theme';
import { name } from './const';

export const Root = styled(Field, { name })(({ theme }) => ({
  [FieldTokens.Gap]: '13px',
  [InputTokens.Gap]: '12px',
  [FieldTokens.LabelColor]: theme.palette['brand gray'],
  [InputTokens.ColorTextPlaceholder]: theme.palette['gray'],
  '&.small': {
    [FieldTokens.Gap]: '4px',
    [InputTokens.Gap]: theme.spacing(1),
  },
})) as unknown as typeof Field;
